import React from 'react';
import CustomImage from '../../../components/custom-image';
import ContentSlider from '../../../components/content-slider';

const SportCulture = () => {
  const slider = {
    slides: [
      <div className="child-education-slider">
        <CustomImage
          className="custom-image"
          imageName="sports-culture.jpg"
          alt="Enviroment Restoration"
          maxWidth="768"
        />
      </div>,
      <div className="child-education-slider">
        <CustomImage
          className="custom-image"
          imageName="sports-culture2.jpg"
          alt="Enviroment Restoration"
          maxWidth="768"
        />
      </div>
    ],
  };
  return (
    <div className="accordion-body">
      <div className="sd-content">
          <div className="left">
            <div className="blue-box">
              <p className="feature-title"><strong>Key Features</strong></p>
              <div className="sd-column">
                <div className="left">
                  <p className="feature-subtitle">More than</p>
                  <p className="bold-text blue-text">20</p>
                  <p className="feature-benifit">initiatives across our Group companies</p>
                </div>
                <div className="right">
                  <p className="bold-text blue-text">97,000</p>
                  <p className="feature-benifit">sports-persons and culture enthusiasts beneﬁted</p>
                </div>
              </div>
              
            </div>
            <div className="bottom-content">
              <p><strong>Types of Interventions</strong></p>
              <p className="p-20">
              Rural sports; Sponsorship for para-athletes; Marathons; Sports tournaments; Music festivals; Football and archery training academies
              </p>
            </div>
          </div>
          <div className="right">
            <ContentSlider
              data={slider.slides}
              customClass="blue-dots-slider"
              slidesToShow={1}
              slidesToScroll={1}
              dots={true}
            />
          </div>
      </div>
    </div>
  );
};

export default SportCulture;
